'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosTime = function IoIosTime(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.5c9.7 0 17.5 7.8 17.5 17.5s-7.8 17.5-17.5 17.5-17.5-7.8-17.5-17.5 7.8-17.5 17.5-17.5z m0 3.1c-0.3 0-0.6 0.3-0.6 0.7s0.3 0.6 0.6 0.6 0.6-0.3 0.6-0.6-0.3-0.7-0.6-0.7z m-13.7 15c0.3 0 0.6-0.3 0.6-0.6s-0.3-0.6-0.6-0.6-0.7 0.3-0.7 0.6 0.3 0.6 0.7 0.6z m2.1 6.8c0.4-0.1 0.4-0.5 0.2-0.8s-0.5-0.4-0.8-0.3-0.4 0.6-0.2 0.9 0.5 0.4 0.8 0.2z m0.2-14c0.2-0.3 0.2-0.7-0.2-0.8s-0.7-0.1-0.8 0.2-0.1 0.7 0.2 0.9 0.6 0.1 0.8-0.3z m4.2-5.8c-0.3 0.1-0.4 0.5-0.2 0.8s0.5 0.4 0.8 0.2 0.4-0.5 0.3-0.8-0.6-0.4-0.9-0.2z m0.9 24.6c0.1-0.3 0.1-0.6-0.3-0.8s-0.7-0.1-0.8 0.2-0.1 0.7 0.2 0.8 0.7 0.1 0.9-0.2z m6.3 2.2c0.3 0 0.6-0.3 0.6-0.6s-0.3-0.7-0.6-0.7-0.6 0.3-0.6 0.7 0.3 0.6 0.6 0.6z m0.6-13.3c0.7-0.3 0.8-1.1 0.5-1.7-0.2-0.4-0.7-0.6-1.1-0.6l-3-5c-0.1-0.4-0.5-0.4-0.8-0.2s-0.3 0.5-0.2 0.9l2.9 4.9c-0.2 0.4-0.2 0.8 0 1.2 0.2 0.2 0.3 0.4 0.5 0.5v9.5c0 0.3 0.3 0.6 0.6 0.6s0.6-0.3 0.6-0.6v-9.5z m6.6 11.3c0.3-0.1 0.4-0.5 0.2-0.8s-0.5-0.4-0.8-0.2-0.4 0.5-0.3 0.8 0.6 0.4 0.9 0.2z m0.2-24c0.2-0.3 0.1-0.7-0.2-0.8s-0.7-0.1-0.9 0.2 0 0.6 0.3 0.8 0.7 0.1 0.8-0.2z m5 18.8c0.2-0.3 0.1-0.7-0.2-0.9s-0.6 0-0.8 0.3-0.1 0.7 0.2 0.8 0.7 0.1 0.8-0.2z m-0.2-13.5c0.3-0.2 0.4-0.6 0.2-0.9s-0.5-0.4-0.8-0.2-0.3 0.5-0.2 0.8 0.5 0.4 0.8 0.3z m1.6 6.9c0.3 0 0.6-0.3 0.6-0.6s-0.3-0.6-0.6-0.6-0.7 0.3-0.7 0.6 0.3 0.6 0.7 0.6z' })
        )
    );
};

exports.default = IoIosTime;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-time.js
// module id = 2332
// module chunks = 0